const GraphQLMultiQuery = require('app/graphql/MultiQuery');
const GraphQLQuery = require('app/graphql/Query');
const GraphQLMutation = require('app/graphql/Mutation');
const ListTable = require('app/ui/list/Table');

class SimilarTab {
    defaultOptions() {
        return {
            '$container': $('<div/>'),
            'product': {'id':null,'name':null},
            'potentialProductLength': 10,
            'searchProductLength': 10,
            'productShowBaseUrl': window.App.get('productShowBaseUrl'),
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onSubmitSearch = this.onSubmitSearch.bind(this);
        this.buildGraphQLParameters = this.buildGraphQLParameters.bind(this);

        this.$container = this.settings.$container;
        if(this.$container.length <= 0){
            window.notify("Can't find container view with selector " + this.settings.selector,'danger');
        }

        this.product = this.settings.product;
        if(!this.product.id){
            window.notify("Missing valid product","error");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.buildTab();
    }


    onDOMReady(){

    }

    buildTab(data){


        this.$tableSimilarProductContainer = $('<div/>')
        .addClass('mb-2');
        this.$tablePotentialProductContainer = $('<div/>')
        .addClass('mb-2');

        this.$searchProductContainer = $('<div/>')
        .addClass('mb-2');

        this.$synthesisContainer = $('<div/>')
        .addClass('white-box');

        this.$content = $("<div/>")
        .addClass('row')
        .append(
            $('<div/>')
            .addClass('col-8 p-2')
            .append(

                $('<div/>')
                .addClass('white-box')
                .append(
                    $('<div/>')
                    .addClass('mb-4')
                    .append(
                        $('<h5/>')
                        .append(window.translate('app.product.show.tabs.similar.list.similar.title'))
                    )
                    .append(this.$tableSimilarProductContainer)
                )
                .append(
                    $('<div/>')
                    .addClass('mb-4')
                    .append(
                        $('<h5/>')
                        .append(window.translate('app.product.show.tabs.similar.list.potential.title'))
                    )
                    .append(this.$tablePotentialProductContainer)
                )
                .append(this.$searchProductContainer)
            )
        )
        .append(
            $('<div/>')
            .addClass('col-4 p-2')
            .append(this.$synthesisContainer)
        )


        this.$container
        .html('')
        .append(this.$content);


        this.loadData();
        this.buildPotentialProductListTable();
        this.buildSearchProductForm();

        this.onDOMReady();
    }

    refresh(){
        this.loadData();
    }


    loadData(){
        var self = this;

        this.$tableSimilarProductContainer
        .html('')
        .append(window.App.generateLoader());

        this.$synthesisContainer
        .html('')
        .append(window.App.generateLoader());

        let queries = [
            this.buildProductQuery(),
        ];

        let query = new GraphQLMultiQuery({
            //parameters
            'queries': queries,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.fillView(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();
    }

    buildProductQuery(){
        var self = this;

        let id = this.product.id;
        let parameters = {
            'id': id,
        };

        let fields = [
            'id',
            'number',
            'reference',
            'price',
            'supplierPrice',
            'unit',
            'quantity',
            'margin',
            'marginRatio',
            'supplier { id name }',
            'range { id name }',
            'identics { id number reference price supplierPrice unit quantity margin marginRatio supplier { id name }} '
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProduct',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': false,
            'addPageInfo': false,
            'addTotalCount': false,
        });

        return query;
    }

    fillView(data){

        this.product = data.supplierProduct;
        this.buildSimilarProductListTable();
        this.buildSynthesis();

    }

    buildSynthesis(){

        this.$synthesisContainer
        .html('')
        .append(
            $('<h5/>')
            .append(window.translate('app.product.show.tabs.similar.synthesis.title'))
        );

        let $list = $('<ul/>')
        .addClass('list-unstyled')
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.number.label'))
                .append(' :')
            )
            .append(this.product.number)
        )
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.reference.label'))
                .append(' :')
            )
            .append(this.product.reference)
        )
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.packaging.label'))
                .append(' :')
            )
            .append(window.formatFloat(this.product.quantity,2) + ' ' +this.product.unit)
        )
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.supplierPrice.label'))
                .append(' :')
            )
            .append(window.formatFloat(this.product.supplierPrice,2) + ' &euro;')
        )
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.price.label'))
                .append(' :')
            )
            .append(window.formatFloat(this.product.price,2) + ' &euro;')
        )
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.margin.label'))
                .append(' :')
            )
            .append(window.formatFloat(this.product.margin,2) + ' &euro;')
        )
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.marginRatio.label'))
                .append(' :')
            )
            .append(window.formatFloat(this.product.marginRatio,2) + '%')
        )
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.supplier.label'))
                .append(' :')
            )
            .append(this.product.supplier.name)
        )
        .append(
            $('<li/>')
            .append(
                $('<span/>')
                .addClass('fw-bold me-1')
                .append(window.translate('app.product.show.tabs.similar.synthesis.range.label'))
                .append(' :')
            )
            .append(this.product.range.name)
        )

        this.$synthesisContainer.append($list);
    }


    buildSimilarProductListTable(){
        var self = this;

        this.$tableSimilarProductContainer
        .html('');

        let fields = [
            'id',
            'number',
            'reference',
            'supplier { id name }',
            'quantity',
            'unit',
            'supplierPrice',
            'price',
            'margin',
            'marginRatio'
        ];

        this.table = new ListTable({
            '$container': this.$tableSimilarProductContainer,
            'tableClass': 'table table-striped product-similar-list',
            'id': 'list-products',
            'length': 10000,
            'data': this.product.identics,
            'columns': [
                {
                    'name': 'number',
                    'label': window.translate('app.product.show.tabs.similar.list.number.label'),
                    'class': 'product-similar-number',
                    'render': function(item,index){
                        return item.number;
                    },
                },
                {
                    'name': 'reference',
                    'label': window.translate('app.product.show.tabs.similar.list.reference.label'),
                    'class': 'product-similar-reference',
                    'render': function(item,index){
                        let urlShow = self.settings.productShowBaseUrl.replace('__ID__',item.id);
                        let $btnShow = $('<a/>')
                        .attr('href',urlShow)
                        .attr('target','_blank')
                        .append(item.reference);
                        return $btnShow;
                    },
                },
                {
                    'name': 'supplier',
                    'label': window.translate('app.product.show.tabs.similar.list.supplier.label'),
                    'class': 'product-similar-supplier',
                    'render': function(item,index){
                        if(item.supplier && item.supplier.id > 0){
                            return item.supplier.name;
                        }else{
                            return '-';
                        }
                    },
                },
                {
                    'name': 'packaging',
                    'label': window.translate('app.product.show.tabs.similar.list.packaging.label'),
                    'class': 'product-similar-packaging',
                    'render': function(item,index){
                        return window.formatFloat(item.quantity,2) + ' '+item.unit;
                    },
                },
                {
                    'name': 'supplierPrice',
                    'label': window.translate('app.product.show.tabs.similar.list.supplierPrice.label'),
                    'class': 'product-similar-supplierPrice',
                    'render': function(item,index){
                        return window.formatFloat(item.supplierPrice,2) + ' &euro;';
                    },
                },
                {
                    'name': 'price',
                    'label': window.translate('app.product.show.tabs.similar.list.price.label'),
                    'class': 'product-similar-price',
                    'render': function(item,index){
                        return window.formatFloat(item.price,2) + ' &euro;';
                    },
                },
                {
                    'name': 'margin',
                    'label': window.translate('app.product.show.tabs.similar.list.margin.label'),
                    'class': 'product-similar-margin',
                    'render': function(item,index){
                        return window.formatFloat(item.margin,2) + ' &euro;' + ' ('+window.formatFloat(item.marginRatio,2)+' %)';
                    },
                },
                {
                    'name': 'action',
                    'label': window.translate('app.product.show.tabs.similar.list.action.label'),
                    'class': 'product-similar-action',
                    'render': function(item,index){
                        let $btnRemove = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-sm btn-danger')
                        .append(
                            $('<i/>')
                            .addClass('fas fa-times')
                        )
                        .on('click',function(){
                            self.onClickRemove(item.id);
                        });
                        return $btnRemove;
                    },
                },

            ]
        });
    }

    buildPotentialProductListTable(){
        var self = this;

        let fields = [
            'id',
            'number',
            'reference',
            'supplier { id name }',
            'quantity',
            'unit',
            'supplierPrice',
            'price',
            'margin',
            'marginRatio'
        ];

        this.table = new ListTable({
            '$container': this.$tablePotentialProductContainer,
            'tableClass': 'table table-striped product-potential-similar-list',
            'id': 'list-products',
            'length': this.settings.potentialProductLength,
            'graphQL': {
                'queryType': 'supplierProducts',
                'fields': fields,
                'parameters': this.buildGraphQLParameters,

            },
            'columns': [
                {
                    'name': 'number',
                    'label': window.translate('app.product.show.tabs.similar.list.number.label'),
                    'class': 'product-potential-similar-number',
                    'render': function(item,index){
                        return item.node.number;
                    },
                },
                {
                    'name': 'reference',
                    'label': window.translate('app.product.show.tabs.similar.list.reference.label'),
                    'class': 'product-potential-similar-reference',
                    'render': function(item,index){
                        let urlShow = self.settings.productShowBaseUrl.replace('__ID__',item.node.id);
                        let $btnShow = $('<a/>')
                        .attr('href',urlShow)
                        .attr('target','_blank')
                        .append(item.node.reference);
                        return $btnShow;
                    },
                },
                {
                    'name': 'supplier',
                    'label': window.translate('app.product.show.tabs.similar.list.supplier.label'),
                    'class': 'product-potential-similar-supplier',
                    'render': function(item,index){
                        if(item.node.supplier && item.node.supplier.id > 0){
                            return item.node.supplier.name;
                        }else{
                            return '-';
                        }
                    },
                },
                {
                    'name': 'packaging',
                    'label': window.translate('app.product.show.tabs.similar.list.packaging.label'),
                    'class': 'product-potential-similar-packaging',
                    'render': function(item,index){
                        return window.formatFloat(item.node.quantity,2) + ' '+item.node.unit;
                    },
                },
                {
                    'name': 'supplierPrice',
                    'label': window.translate('app.product.show.tabs.similar.list.supplierPrice.label'),
                    'class': 'product-potential-similar-supplierPrice',
                    'render': function(item,index){
                        return window.formatFloat(item.node.supplierPrice,2) + ' &euro;';
                    },
                },
                {
                    'name': 'price',
                    'label': window.translate('app.product.show.tabs.similar.list.price.label'),
                    'class': 'product-potential-similar-price',
                    'render': function(item,index){
                        return window.formatFloat(item.node.price,2) + ' &euro;';
                    },
                },
                {
                    'name': 'margin',
                    'label': window.translate('app.product.show.tabs.similar.list.margin.label'),
                    'class': 'product-potential-similar-margin',
                    'render': function(item,index){
                        return window.formatFloat(item.node.margin,2) + ' &euro;' + ' ('+window.formatFloat(item.node.marginRatio,2)+' %)';
                    },
                },
                {
                    'name': 'action',
                    'label': window.translate('app.product.show.tabs.similar.list.action.label'),
                    'class': 'product-potential-similar-action',
                    'render': function(item,index){
                        let $btnAdd = $('<button/>')
                        .attr('type','button')
                        .addClass('btn btn-sm btn-success')
                        .append(
                            $('<i/>')
                            .addClass('fas fa-check')
                        )
                        .on('click',function(){
                            self.onClickAdd(item.node.id);
                        });
                        return $btnAdd;
                    },
                },

            ]
        });
    }

    buildGraphQLParameters(){
        let filters = {
            'matchReference': this.product.reference,
            'notStatus': 3,
            'except': [this.product.id],
            'notSupplier': this.product.supplier.id,
            'range': this.product.range.id
        };

        let orderBy = 'reference';
        let dir = "ASC";
        let parameters = {
            'filter' : filters,

            'orderBy': orderBy,
            'dir': dir,
        };


        return parameters;
    }

    buildSearchProductForm(){
        this.$searchProductResultContainer = $('<div/>')
        .addClass('mt-2');
        this.$inputSearch = $('<input/>')
        .attr('type','text')
        .attr('placeholder',window.translate('app.product.show.tabs.similar.search.placeholder'))
        .addClass('form-control')
        .on('change',this.onSubmitSearch)

        this.$form = $('<form/>')
        .addClass('product-search-form')
        .append(
            $('<h5/>')
            .append(window.translate('app.product.show.tabs.similar.search.title'))
        )
        .append(this.$inputSearch)
        .on('submit',this.onSubmitSearch);

        this.$searchProductContainer
        .append(this.$form)
        .append(this.$searchProductResultContainer);
    }

    onSubmitSearch(event){
        event.preventDefault();
        event.stopPropagation();

        this.$searchProductResultContainer
        .html('')
        .append(window.App.generateLoader());


        var self = this;

        let id = this.product.id;
        let parameters = {
            'first': this.settings.searchProductLength,
            'orderBy': 'reference',
            'dir': "ASC",
            'filter': {
                'notStatus': 3,
                'search': this.$inputSearch.val()
            },
        };

        let fields = [
            'id',
            'number',
            'reference',
            'supplier { id name }',
            'range { name }'
        ];

        let query = new GraphQLQuery({
            //parameters
            'queryType': 'supplierProducts',
            'parameters': parameters,
            'fields': fields,
            'hasEdges': true,
            'addPageInfo': false,
            'addTotalCount': true,

            //callbacks
            'before': function(){
            },
            'success': function(data){
                self.drawSearchResults(data);
            },
            'error': function(message, data){
                console.error(message,data);
                window.notify(message,"danger");
            },
            'after': function(){
            }
        });

        query.execute();

    }

    drawSearchResults(data){
        this.results = data.edges;

        if(this.results.length <= 0){

            this.$searchProductResultContainer
            .html('')
            .append(
                $('<div/>')
                .addClass('alert alert-info')
                .append(window.translate('noResult'))
            );
        }else{
            let $list = $('<ul/>')
            .addClass('list-group search-list');

            for(var i in this.results){
                let product = this.results[i].node;

                let $item = this.buildResultItem(product);

                $list.append(
                    $('<li/>')
                    .addClass('list-group-item search-list-item')
                    .append($item)
                )
            }

            this.$searchProductResultContainer
            .html('')
            .append($list);
        }
    }

    buildResultItem(product){
        var self = this;
        let $item = $('<div/>');

        let $btnAdd = $('<button/>')
        .attr('type','button')
        .addClass('btn btn-sm btn-success')
        .append(
            $('<i/>')
            .addClass('fas fa-check')
        )
        .on('click',function(){
            self.onClickAdd(product.id);
        });

        let label = product.reference;
        if(product.number){
            label = product.number + ' - ' + label;
        }
        let subLabel = product.supplier.name;
        if(product.range){
            subLabel += ' | ' + product.range.name
        }
        $item
        .append(
            $('<div/>')
            .addClass('float-end')
            .append($btnAdd)
        )
        .append(
            $('<p/>')
            .addClass('fw-bold')
            .append(label)
        )
        .append(
            $('<p/>')
            .addClass('text-muted')
            .append(subLabel)
        )
        return $item;
    }

    onClickAdd(id){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'parent': {
                'value': this.product.id,
                'type': 'Int!'
            },
            'child': {
                'value': id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "SubmitSupplierProductIdenticAssociation",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
                self.refresh();
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }
    onClickRemove(id){
        var self = this;

        let fields = [
            'success',
            'message',
            'errors { key, value }',
        ];
        let variables = {
            'parent': {
                'value': this.product.id,
                'type': 'Int!'
            },
            'child': {
                'value': id,
                'type': 'Int!'
            }
        };
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': "DeleteSupplierProductIdenticAssociation",
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                window.notify(data.message,"success");
                self.refresh();
            },
            'error': function(message, xhr){
                window.notify(message,"error");
            },
            'after': function(){
                //do nothing
            }
        });
        mutation.execute();
    }
}

module.exports = SimilarTab;

